<script setup>
import 'vue3-carousel/dist/carousel.css';
import {Carousel, Navigation, Slide} from 'vue3-carousel';
import {ref} from "vue";
import {useI18n} from "vue-i18n";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import LogosSection from "@/components/Components/Home/LogosSection.vue";

const {locale} = useI18n();

const openUrl = (url) => window.open(url, '_blank');

// Carousel configuration
const config = {
  itemsToShow: 1,
  snapAlign: 'left',

  // 'breakpointMode' determines how the carousel breakpoints are calculated
  // Acceptable values: 'viewport' (default) | 'carousel'
  // 'viewport' - breakpoints are based on the viewport width
  // 'carousel' - breakpoints are based on the carousel width
  breakpointMode: 'carousel',

  // Breakpoints are mobile-first
  // Any settings not specified will fall back to the carousel's default settings
  breakpoints: {
    // 300px and up
    300: {
      itemsToShow: 1,
      snapAlign: 'left',
    },
    // 400px and up
    900: {
      itemsToShow: 3,
      snapAlign: 'left',
    },
    // 500px and up
    1300: {
      itemsToShow: 4,
      snapAlign: 'left',
    },
  },
};

const slides = ref([
  {
    title: '"Не си сама": Женя, която превърна AI в подкрепа за майките',
    image: '/static/news/presentation.jpg',
    url: 'https://businessnovinite.bg/esg/ne-si-sama-zhenja-kojato-prevarna-ai-v-podkrepa-za-majkite.html',
  },
  {
    title: 'AI приложение за майки: Над 50% от младите майки не получават нужната подкрепа',
    image: '/static/news/presentation2.png',
    url: 'https://bnt.bg/news/ai-prilozhenie-za-maiki-nad-50-ot-mladite-maiki-ne-poluchavat-nuzhnata-podkrepa-v400582-343068news.html',
  },
  {
    title: 'Следродилната депресия: жени помагат на жени',
    image: 'https://cdn.btv.bg/media/images/640x360/Jul2025/2113598699.jpg',
    url: 'https://www.btv.bg/shows/predi-obed/videos/sledrodilnata-depresija-zheni-pomagat-na-zheni.html',
  },
  {
    title: 'Ново приложение ще помага на жени със следродилна депресия',
    image: 'https://bnt.bg/f/media_video/b/393/2d0b97cd5527e8aff11a7bf3310305a0.png',
    url: 'https://bnt.bg/news/novo-prilozhenie-shte-pomaga-na-zheni-sas-sledrodilna-depresiya-v393986-340426news.html',
  },
  {
    title: 'Проучване разкрива какви са проблемите на съвременните млади майки',
    image: 'https://bgonair.bg/files/download/22412',
    url: 'https://www.bgonair.bg/a/36-sutreshen-blok/385064-prouchvane-razkriva-kakvi-sa-problemite-na-savremennite-mladi-mayki',
  },
  {
    title: 'Вина, самота, несигурност: картината на следродилната депресия в България',
    image: 'https://i.actualno.com/actualno_2013/upload/2025/06/17/0755524001750160034_big.webp',
    url: 'https://www.actualno.com/interview/vina-samota-nesigurnost-kartinata-na-sledrodilnata-depresija-v-bylgarija-video-news_2460343.html',
  },
  {
    title: 'Ново приложение в помощ на младите майки',
    image: 'https://static.bnr.bg/gallery/cr/medium/e60f1a8d8d5fcd3b6847e7d65e33e4cf.jpg',
    url: 'https://bnr.bg/sofia/post/102171185/novo-prilojenie-v-pomosht-na-mladite-maiki',
  },
  {
    title: 'Д-р Стоянка Черкезова от БАН за следродилната депресия',
    image: 'https://cdn.btv.bg/media/images/940x530/Apr2015/2110398214.webp',
    url: 'https://btvradio.bg/intervuta/za-grada/doc-stojanka-cherkezova-ot-ban.html',
  },
  {
    title: 'За сблъсъка със следродилната депресия от първо лице',
    image: '/static/news/zh1.png',
    url: 'https://www.bgonair.bg/a/2-bulgaria/361232-za-sblasaka-sas-sledrodilnata-depresiya-ot-parvo-litse-video',
  },
  {
    title: '"Мъмфидънт": Изкуствен интелект в помощ на майките след раждане',
    image: 'https://static.bnr.bg/gallery/cr/medium/4f61b8d6f9be0b823d5f076be5d8178c.jpg',
    url: 'https://bnr.bg/hristobotev/post/102120723/dimitrova',
  },
  {
    title: ' Femtech Founder on the Mental Health Problems Mothers Face and Investors Ignore ',
    image: 'https://therecursive.com/wp-content/uploads/2025/03/momfident-team-900x471.png',
    url: 'https://therecursive.com/zhenya-dimitrova-momfident-femtech-mothers-mental-health-startup/',
  },
  {
    title: 'Награда за Спиноф 2024',
    image: 'https://iphs.eu/wp-content/uploads/2024/07/SpinOff24_2-1024x576.jpg',
    url: 'https://iphs.eu/2024/07/03/%D0%BD%D0%B0%D0%B3%D1%80%D0%B0%D0%B4%D0%B0-%D0%B7%D0%B0-%D1%81%D0%BF%D0%B8%D0%BD%D0%BE%D1%84-2024/',
  },
  {
    title: '"Не си сама": майки разработват инструменти за взаимопомощ за следродилна депресия',
    image: 'https://img.capital.bg/shimg/zx1200y675_4775830.jpg?v=1747303793',
    url: 'https://www.capital.bg/politika_i_ikonomika/zdraveopazvane/2025/04/29/4775829_ne_si_sama_maiki_razrabotvat_instrumenti_za/',
  },
  {
    title: 'Български стартъп променя нагласите на хората за психичното здраве',
    image: 'https://www.economic.bg/web/files/articles/146583/narrow_image/thumb_1040x585_img-5689.JPG',
    url: 'https://www.economic.bg/bg/a/view/bylgarski-startyp-promenja-naglasite-na-horata-za-psihicheskoto-zdrave',
  }
])

</script>

<template>
  <!-- Resizable container for testing 'carousel' breakpointMode -->
  <!-- Drag the right edge to adjust the width and see the breakpoints change -->
  <div class="heading">{{ $t('home-news-heading') }}</div>
  <LogosSection/>
  <div class="carousel-wrapper">
    <Carousel v-bind="config">
      <Slide v-for="(slide,index) in slides" :key="index">
        <div class="carousel__item">
          <div class="image" v-bind:style="{'background-image': 'url(' + slide.image + ')'}">
          </div>
          <div class="title">{{ slide.title }}</div>
          <MainButton class="read-more" @click="openUrl(slide.url)">
            {{ $t('read-more') }}
          </MainButton>
        </div>
      </Slide>
      <template #addons>
        <Navigation>
          <template #prev>
            <button>&#8592;</button>
          </template>
          <template #next>
            <button>&#8594;</button>
          </template>
        </Navigation>
      </template>
    </Carousel>
  </div>
  <div class="media-more">
    <router-link :to="locale === 'en' ? '/en/media' : '/media'" class="media-more__link">
      {{ locale === 'bg' ? 'Към всички медии' : 'View all media' }} &rarr;
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.heading {
  font-size: 25px;
  font-weight: 400;
  line-height: 1;
  color: #6B6B9C;
  text-align: center;
  margin: 20px 0 40px 0;
}
:deep(.carousel__viewport) {
  padding-top: 40px;
}
:deep(.carousel__prev) {
  position: absolute!important;
  top: 0!important;
  left: 10px;
  button {
    border: 0;
    background: transparent;
    color: $color-purple;
  }
}

:deep(.carousel__next) {
  position: absolute!important;
  top: 0!important;
  right: 10px;
  button {
    border: 0;
    background: transparent;
    color: $color-purple;
  }
}

.carousel-wrapper {
  .carousel__item {
    width: 100%;
    background-color: $color-pink-light;
    padding: 20px 20px;
    border-radius: 20px;
    //height: 300px;
    font-size: 13px;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 192, 203, 0.3); // Rose color overlay
        border-radius: 20px;
        z-index: 1;
        pointer-events: none;
      }
    }

    .image {
      padding-top: 50%;
      background-size: cover;
      background-position: center;
      border-radius: 10px;
      margin-bottom: 10px;
      position: relative;
      z-index: 2;
    }
    .read-more {
      width: 100%;
      margin-top: 20px;
      position: relative;
      z-index: 2;
    }

    .title {
      color: $color-purple;
      font-family: $font-semi-bold;
      height: 50px;
      position: relative;
      z-index: 2;
    }
  }
}

.media-more {
  text-align: center;
  margin-top: 26px;
}

.media-more__link {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: $color-pink-dark-2;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

@media (max-width: 768px) {
  .heading {
    font-size: 20px;
    margin: 16px 12px 24px;
    padding: 0 8px;
  }
  .carousel-wrapper .carousel__item {
    padding: 16px;
    margin: 0 8px;
    font-size: 12px;
  }
  .carousel-wrapper .carousel__item .title {
    height: auto;
    min-height: 44px;
    font-size: 13px;
  }
  .carousel-wrapper .carousel__item .image {
    padding-top: 56%;
  }
}

</style>